import type { ReactNode } from 'react';

export const symbol_stylus_fountain_pen: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M331-326q-10.77 0-19.23-6.31-8.46-6.3-10.77-16.69l-77-317q-2-8 .5-16t8.5-13l227-207q8.19-8 20.09-8 11.91 0 19.91 8l227 207q6 5 8.5 13t.5 16l-77 317q-2.31 10.39-10.77 16.69Q639.77-326 629-326H331Zm23-60h252l68-277-164-148v143q14 8 23 22.06 9 14.06 9 30.94 0 25.27-18.22 43.14-18.22 17.86-44 17.86T436-571.86q-18-17.87-18-43.14 0-16.88 9-30.94Q436-660 450-668v-143L286-663l68 277ZM203-120q-16 0-24.5-12.5T175-160l6-17q8-22 26.84-35.5T250-226h460q23.32 0 42.16 13.5Q771-199 779-177l6 17q5 15-3.5 27.5T757-120H203Z"
		/>
	</svg>
);
